import { render } from "./imageModal.vue?vue&type=template&id=2b67f481"
import script from "./imageModal.vue?vue&type=script&lang=js"
export * from "./imageModal.vue?vue&type=script&lang=js"

import "./imageModal.vue?vue&type=style&index=0&id=2b67f481&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__